import { Box, Typography } from '@mui/material'

// Marks a section of the design that this endpoint doesn't provide data for
// yet, so it's obvious in the DOM and can't be mistaken for real content.
export let NotYetAvailable = ({
  label,
  height,
}: {
  label: string
  height?: number
}) => (
  <Box
    data-testid="not-yet-available"
    sx={{
      height: height ?? 96,
      border: '1px dashed rgba(255,255,255,0.25)',
      borderRadius: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'text.disabled',
    }}
  >
    <Typography variant="body2" color="text.disabled">
      {label} — not yet available
    </Typography>
  </Box>
)
